import { render, staticRenderFns } from "./DataTableTabs.vue?vue&type=template&id=13d3eca0&"
import script from "./DataTableTabs.vue?vue&type=script&lang=ts&"
export * from "./DataTableTabs.vue?vue&type=script&lang=ts&"
import style0 from "./DataTableTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
